"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Phone, Mail, MapPin } from "lucide-react";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="get-in-touch" ref={ref} className={`relative py-24 px-6 bg-background overflow-hidden transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <VinylBackground />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Get In Touch
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Ready to make your special day unforgettable? Reach out and let's start planning your perfect celebration.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-start">
          <ContactDetails />
          
          <div className="lg:col-span-2">
            <Card className="bg-background shadow-medium border border-muted overflow-hidden">
              <CardContent className="p-0">
                <div className="w-full overflow-hidden rounded-lg">
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf4S9VlIH1pLHeqos2lleAhuUedtkd3688l6M0XZNNoEQjQtw/viewform?embedded=true" className="w-full border-0" style={{
                  height: '2453px',
                  minHeight: '600px'
                }} title="Contact Form">
                    Loading…
                  </iframe>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}
function ContactDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <Card ref={ref} className={`bg-[hsl(0,0%,98%)] shadow-medium border border-muted transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <CardContent className="space-y-6 py-8">
        <div className="flex items-start gap-4">
          <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Phone className="size-5 text-primary-dark" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">Phone</h3>
            <Link to="tel:(303) 555-1234" className="text-muted-foreground hover:text-primary-dark transition-colors duration-[var(--duration-fast)]">
              (303) 555-1234
            </Link>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="size-10 rounded-full bg-secondary/10 flex items-center justify-center shrink-0">
            <Mail className="size-5 text-secondary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">Email</h3>
            <Link to="mailto:info@jordanebner.com" className="text-muted-foreground hover:text-secondary-dark transition-colors duration-[var(--duration-fast)]">
              info@jordanebner.com
            </Link>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="size-10 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
            <MapPin className="size-5 text-accent-dark" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">Location</h3>
            <p className="text-muted-foreground">Denver, CO</p>
          </div>
        </div>

        <div className="pt-6 border-t border-muted">
          <p className="text-sm text-muted-foreground">Available by appointment</p>
        </div>
      </CardContent>
    </Card>;
}
function VinylBackground() {
  return <div className="absolute right-0 top-1/2 -translate-y-1/2 w-64 h-64 opacity-5 pointer-events-none">
      <svg viewBox="0 0 200 200" className="w-full h-full animate-[spin_20s_linear_infinite]" style={{
      animationDirection: "reverse"
    }}>
        <circle cx="100" cy="100" r="95" fill="currentColor" />
        <circle cx="100" cy="100" r="70" fill="var(--color-background)" />
        <circle cx="100" cy="100" r="50" fill="currentColor" />
        <circle cx="100" cy="100" r="15" fill="var(--color-background)" />
        <circle cx="100" cy="100" r="8" fill="currentColor" />
      </svg>
    </div>;
}